import { render } from "./actionDialog.vue?vue&type=template&id=0216c5ad&scoped=true"
import script from "./actionDialog.vue?vue&type=script&lang=js"
export * from "./actionDialog.vue?vue&type=script&lang=js"

import "./actionDialog.vue?vue&type=style&index=0&id=0216c5ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0216c5ad"]])

export default __exports__